export default class LoadingController {
    constructor(parentSelector) {
        this.loadingRoot = document.querySelector(`${parentSelector} .js_loading`);
        this.start();
    }

    start() {
        this.loadingRoot.classList.remove('hidden');
    }

    stop() {
        this.loadingRoot.classList.add('hidden');
    }
}
